import React from 'react';
import { Box } from '@mui/material';

import { SectionPaper } from './SectionPaper';
import { MetricCard } from './MetricCard';
import { MeterChart } from './MeterChart';
import { MeterSummaryResult } from '../../api/hooks/meters/fetchMeterSummaries';
import { useIsMobile } from '../../api/hooks/isMobile/isMobile';

interface ChartDataItem {
  time: string;
  value: number;
  startTime: number;
}

interface MetricData {
  title: string;
  value: string | number;
  subtitle?: string;
}

interface AnalyticsSectionProps {
  title: string;
  metrics: MetricData[];
  meterData: MeterSummaryResult[];
  processChartData: (meter: MeterSummaryResult) => ChartDataItem[];
  getMeterTitle: (meterId: string) => string;
  isDurationMeter: (meterId: string) => boolean;
}

export const AnalyticsSection: React.FC<AnalyticsSectionProps> = ({
  title,
  metrics,
  meterData,
  processChartData,
  getMeterTitle,
  isDurationMeter,
}) => {
  const isMobile = useIsMobile();
  return (
    <SectionPaper title={title}>
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={isMobile ? 'column' : 'row'}
        gap={3}
      >
        {metrics.map((metric, index) => (
          <Box key={index}>
            <MetricCard
              title={metric.title}
              value={metric.value}
              subtitle={metric.subtitle}
              variant="large"
            />
          </Box>
        ))}
      </Box>
      <Box
        mt={4}
        display={'flex'}
        flexDirection={isMobile ? 'column' : 'row'}
        gap={3}
      >
        {meterData.map((meter) => (
          <Box width={isMobile ? '100%' : '50%'} key={meter.meterId}>
            <MeterChart
              title={getMeterTitle(meter.meterId)}
              data={processChartData(meter)}
              meterId={meter.meterId}
              isDuration={isDurationMeter(meter.meterId)}
            />
          </Box>
        ))}
      </Box>
    </SectionPaper>
  );
};
